'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parse = exports.validate = exports.normalize = exports.isValidEmail = exports.toValidEmail = exports.isAbsoluteHTTPResource = exports.isRelativeHTTPResource = exports.isValidHTTPResource = exports.isValidTelephone = exports.stripHypertextProtocols = undefined;

var _url = require('url');

/**
 * A functional version of the string prototype method.
 *
 * @param {String}
 *
 * @returns {String}
 * @private.
 */
var trim = function trim() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return String.prototype.trim.call(str);
};

/**
 * A functional version of the string prototype method.
 *
 * @param {String}
 *
 * @returns {String}
 * @private.
 */
var toLowerCase = function toLowerCase() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return String.prototype.toLowerCase.call(str);
};

/**
 * A noop that can be passed as the default formatter
 * after normalization of the URL.
 *
 * @param {String}
 *
 * @returns {String}
 * @private
 */
var noop = function noop(str) {
  return str;
};

var stripHypertextProtocols = exports.stripHypertextProtocols = function () {
  var HYPERTEXT_PROTOCOL_RE = /^https?:\/{2}/;
  var HYPERTEXT_PROTOCOL_RE_REL = /^https?:/;

  /**
   * Required to work around an iOS Safari bug on
   * `IFrame` `src` attributes.
   *
   * SEE: issue #44 - `https://github.com/raywhite/markup/issues/44`.
   *
   * @param {String}
   *
   * @returns {String}
   */
  return function (str) {
    return str.replace(HYPERTEXT_PROTOCOL_RE, '//').replace(HYPERTEXT_PROTOCOL_RE_REL, '');
  };
}();

var toValidTelephone = function () {
  var ENCASED_DIGITS_RE = /\((\d{1,4})\)/;
  var DEFORMATTED_TEL_RE = /^\d{8,15}$/;

  /**
   * Does a decent job of efficiently determining is something
   * resembles a telephone number.
   *
   * TODO: This should be extended to format the resource.
   *
   * @param {String}
   * @param {Function}
   *
   * @returns {String}
   * @private
   */
  return function () {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    str = trim(str);
    if (!str) return '';

    var _str = str;

    if (str[0] === '+') str = str.substring(1);
    str = str.split(/ |-/).filter(function (token) {
      return token;
    }).join('');
    str = str.replace(ENCASED_DIGITS_RE, '$1');

    if (DEFORMATTED_TEL_RE.test(str)) return format(_str, str);

    return '';
  };
}();

var isValidTelephone = exports.isValidTelephone = function isValidTelephone(str) {
  return Boolean(toValidTelephone(str));
};

var toValidHTTPResource = function () {
  var FORWARD_SLASH = '/';

  /**
   * Does a decent job of efficiently determining is something
   * resembles a URL.
   *
   * @param {String}
   *
   * @return {String}
   * @private
   */
  return function () {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    str = trim(str);
    if (!str) return '';

    var tokens = str.split(FORWARD_SLASH).filter(function (token) {
      return !!token;
    });

    var pathname = tokens.length ? '' + tokens.join(FORWARD_SLASH) : '';
    return format(pathname);
  };
}();

// TODO: document.
var isValidHTTPResource = exports.isValidHTTPResource = function isValidHTTPResource() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return Boolean(toValidHTTPResource(str));
};

// TODO: document.
var isRelativeHTTPResource = exports.isRelativeHTTPResource = function isRelativeHTTPResource() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return !(0, _url.parse)(str).hostname;
};

// TODO: document.
var isAbsoluteHTTPResource = exports.isAbsoluteHTTPResource = function isAbsoluteHTTPResource() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return !isRelativeHTTPResource(str);
};

var toValidEmail = exports.toValidEmail = function () {
  var DOMAIN_RE = /^[a-zA-Z0-9\-_.]+\.[a-zA-Z]{2,}$/i;
  var LOCAL_RE = /^[a-z0-9_\-.+]{2,}$/i;

  /**
   * Does a decent job of efficiently determining if something
   * resembles an email address.
   *
   * TODO: This should be extended to format the resource.
   *
   * @param {String}
   *
   * @return {String}
   * @private
   */
  return function () {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    str = trim(str);
    if (!str) return '';

    var tokens = str.split('@').filter(function (token) {
      return token;
    });

    if (tokens.length === 2) {
      if (LOCAL_RE.test(tokens[0]) && DOMAIN_RE.test(tokens[1])) return format(str);
    }

    return '';
  };
}();

var isValidEmail = exports.isValidEmail = function isValidEmail(str) {
  return Boolean(toValidEmail(str));
};

var normalize = exports.normalize = function () {
  var HYPERTEXT = 'https?:';
  var TELEPHONE = 'tel:';
  var EMAIL = 'mailto:';

  // Used to detect either `http` or `https`.
  var HYPERTEXT_RE = new RegExp('^(?:' + HYPERTEXT + '$)', 'i');
  var VALID_PROTOCOL_RE = new RegExp('^(?:' + HYPERTEXT + '|' + TELEPHONE + '|' + EMAIL + ')$');
  var PROTOCOL_RE = /(^[A-Z]+:)/i;
  var SLASHES_RE = /^\/{1,2}(?!\/)/;

  return function () {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    // Secure http is the default protocol where a protocol is missing.
    var protocol = 'https:';
    var match = null;

    // Trim any flanking whitespace, then check that we still have a string.
    str = trim(str);
    if (!str) return '';

    // fragment URLs, retain as is
    if (str[0] === '#') return str;

    // Root relative URL, retain as is
    if (str[0] === '/' && str[1] !== '/') return str;

    // Match the protocol where present, and trim it off the string.
    match = PROTOCOL_RE.exec(str);
    if (match !== null) {
      protocol = toLowerCase(match.shift());

      // The protocol can only be of a known type.
      if (!VALID_PROTOCOL_RE.test(protocol)) return '';
      str = str.substring(protocol.length);
    }

    // Match the colon and prefix slashes where present, and trim them of the string.
    match = SLASHES_RE.exec(str);
    if (match !== null) str = str.substring(match[0].length);

    var resource = '';
    if (HYPERTEXT_RE.test(protocol)) {
      resource = toValidHTTPResource(str);
      if (resource) return protocol + '//' + resource;
    }

    if (protocol === TELEPHONE) resource = toValidTelephone(str);
    if (protocol === EMAIL) resource = toValidEmail(str, toLowerCase);
    if (resource) return '' + protocol + resource;

    return '';
  };
}();

var validate = exports.validate = function validate() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return Boolean(normalize(str));
};

/**
 * Just a composition of normalize and stdlibs parse.
 *
 * @param {String}
 *
 * @returns {Object}
 */
var parse = exports.parse = function parse(str) {
  return (0, _url.parse)(normalize(str));
};